module.exports = __webpack_public_path__ + "static/media/a6.b75375c1.jpg";